import ajax from '@/utils/ajax'

/**
 * @module 油站信息
 */

// 分页获取油站列表
export const getGasList = params => ajax.post('gasInfo/getGasInfoList', params)

// 获取用户名下所有油站
export const getAllGasInfoList = params => ajax.post('gasInfo/getAllGasInfoList', params)

// 获取商户信息
export const getCompanyInfo = params => ajax.post('gasInfo/getCompanyInfo', params)

// 修改油站详情
export const updateGasInfo = params => ajax.post('gasInfo/updateGasInfo', params)

// 油站标签
export const getTags = params => ajax.post('gasInfo/getBindSelfTags', params)

// 营业状态
export const getBusinessStatus = params => ajax.post('gasInfo/getBusinessStatus', params)

// 获取地理位置标识
export const getGasLocationType = params => ajax.post('gasInfo/getGasLocationType', params)

// 暂时关闭油站
export const closeGasInfo = params => ajax.post('gasInfo/closeGasInfo', params)

// 查询修改记录
export const companyGasInfoLog = params => ajax.post('gasInfo/companyGasInfoLog', params)

/**
 * @module 油站详情-油站资质信息 
 */
// 油站资质详情
export const gasInfoDetail = params => ajax.post('gasInfo/gasInfoDetail', params)

// 三证审核示例图片
export const licenceExampleInfo = params => ajax.post('gasInfo/licenceExampleInfo', params)

// 图片加水印
export const addWatermark = params => ajax.post('gasInfo/addWatermark', params)

// 查询油站三证过期提示
export const gasLicenceExpiryTips = params => ajax.post('gasInfo/gasLicenceExpiryTips', params)

// 2. 资质审核状态提醒
export const queryGasInfoCheckNotice = params => ajax.post('gasInfo/queryGasInfoCheckNotice', params)

/**
 * @module 油枪管理
 */

// 油枪列表
export const getGasGunList = params => ajax.post('gasInfo/getGasGunList', params)

// 新增油枪
export const addGasGun = params => ajax.post('gasInfo/addGasGun', params)

// 启用/禁用油枪
export const openGasGun = params => ajax.post('gasInfo/toOpenGun', params)

// 获取修改弹窗的油号, 暂时用不到
export const getGasGunById = params => ajax.get('gasInfo/getGasGunById', params)

// 提交修改弹窗油号
export const updateGasGun = params => ajax.post('gasInfo/updateGasGun', params)

// 获取变更记录
export const oilGunLog = params => ajax.post('gasInfo/viewOilGunLog', params)

// 油号列表
export const getOilNumList = params => ajax.post('gasInfo/getOilNumList', params)

/**
 * @module 油价管理
 */

// 油价列表
export const getGasPriceList = params => ajax.post('gasInfo/getOilPriceByPage', params)

// 提交修改油价
export const updateOilPrice = params => ajax.post('oilPrice/updateOilPrice', params)

// 修改记录
export const checkLog = params => ajax.post('gasInfo/viewOilPriceLog', params)

// 指定人群枚举值
export const getOption = () => ajax.post('gasInfo/xxx')

/**
 * @module 营业时间
 */

// 获取营业时间
export const getBusinessHour = params => ajax.post('gasInfo/getGasBusinessHour', params)

// 设置营业时间
export const setBusinessHour = params => ajax.post('gasInfo/updateGasBusinessHour', params, { noMessage: true })

// 营业时间操作记录
export const getOpenTimeRecord = params => ajax.post('gasInfo/getBusinessHoursChangeRecords', params)

// 是否存在审批中的单据
export const existUndoApprovalForm = params => ajax.post('gasInfo/existUndoApprovalForm', params)

// 获取周期改价中油号列表
export const inCyclePriceTaskOilNos = params => ajax.post('oilPrice/inCyclePriceTaskOilNos', params)

// 油站表单接口
export const getOilPriceDetail = params => ajax.post('oilPrice/getOilPriceDetail', params)

// 撤销修改
export const revokeApply = params => ajax.post('gasInfo/revokeApply', params)

// 获取油站修改时间消息通知
export const getGasMsg = params => ajax.post('gasInfo/apply/gasMsg', params)

// 查询账单核销消息通知
export const billInvoiceNotification = params => ajax.post('billInvoice/billInvoiceNotification', params)
